import { Component, OnInit } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { AlertService, HelperService } from "../../../services";
import { AppState, AppFields } from "../../../store";
import { ClubTeamsService } from "../../../services/club-teams.service";

@Component({
  selector: "app-system-update",
  templateUrl: "./system-update.component.html",
  styleUrls: ["./system-update.component.css"]
})

export class SystemUpdateComponent implements OnInit {
  tgsSystemID: number;
  constructor(
    // private dashboardService: MyProfileDashboardService,
    private loader: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private route: ActivatedRoute,
    public helperService: HelperService,
    public service: ClubTeamsService,
    //public service: TGSServices,
    private store: Store<AppState>
  ) {
    this.service.links = [
      { title: 'System Updates', url: null }
    ];
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe((team) => {
      if (team) {
        this.tgsSystemID = 2;
      } else {
        this.tgsSystemID = 1;
      }
    });
  }

  ngOnInit() {
    this.loader.show();
    this.getTGSSystemUpdateList();
  }

  systemUpdateList: any[] = [];
  getTGSSystemUpdateList() {
   
    this.service.getTgsSystemUpdateListByTgsSystemID(this.tgsSystemID).subscribe((rs: any) => {
      this.loader.hide();
      if (rs) {
        this.systemUpdateList = rs.data;
      }
    }, error => {
      console.log(error);
      this.loader.hide();
      this._alertService.error(error.error);
    });
  }

  redirect(link) {
    window.location.href = link;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/system-update/system-update.component.ts